﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_dialogPaintStrapList from './tpl/dialogPaintStrapList.html';
import View_DialogPaintStrapListItem from './dialogPaintStrapListItem';

export default Marionette.CollectionView.extend({
    tagName: 'dialogPaintStrapList',
    className:'row',
    childViewContainer: '#dialogPaintStrapList',
    childView: View_DialogPaintStrapListItem,
    getTemplate: function () {
        return tpl_dialogPaintStrapList();
    },
    initialize: function () {
        this.app = this.options.app;
    },
    buildChildView: function(child, ChildViewClass, childViewOptions){
        var options = _.extend({model: child}, childViewOptions);
        options.app = this.app;
        var view = new ChildViewClass(options);
        return view;
    }
});
